import Flickity from 'flickity';

function cleanupFlickityControls(slider) {
  const controlsWrapper = slider.querySelector('.flickity-controls');

  if (controlsWrapper) {
    controlsWrapper.remove();
  }

  delete slider.dataset.controlsMoved;
}

function setupFlickityControls() {
  const sliders = document.querySelectorAll('[data-flickity].u-flickity-custom-controls');

  sliders.forEach((slider, index) => {
    const flkty = Flickity.data(slider);

    if (!flkty || !slider.classList.contains('flickity-enabled')) {
      cleanupFlickityControls(slider);
      return;
    }

    if (slider.dataset.controlsMoved === 'true') {
      return;
    }

    const prevButton = slider.querySelector('.flickity-prev-next-button.previous');
    const nextButton = slider.querySelector('.flickity-prev-next-button.next');
    const pageDots = slider.querySelector('.flickity-page-dots');

    if (!prevButton && !nextButton && !pageDots) {
      cleanupFlickityControls(slider);
      return;
    }

    const controlsWrapper = document.createElement('div');
    controlsWrapper.className = 'flickity-controls';
    controlsWrapper.setAttribute('data-flickity-controls-for', index + 1);

    const navWrapper = document.createElement('div');
    navWrapper.className = 'flickity-nav';

    slider.appendChild(controlsWrapper);

    if (pageDots) {
      controlsWrapper.appendChild(pageDots);
    }

    controlsWrapper.appendChild(navWrapper);

    if (prevButton) {
      navWrapper.appendChild(prevButton);
    }

    if (nextButton) {
      navWrapper.appendChild(nextButton);
    }

    slider.dataset.controlsMoved = 'true';
  });
}

window.addEventListener('load', setupFlickityControls);
window.addEventListener('resize', setupFlickityControls);

const observer = new MutationObserver(() => {
  setupFlickityControls();
});

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
  childList: true,
  subtree: true,
});